import React from "react";
import { connect } from 'react-redux';

import ProductTypeForm from "./ProductTypeForm";
import * as Yup from "yup";
import * as actions from './store/productTypeActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";

const ProductTypeCreate = props => {
    const { loading, activeCustomer, translations, permissions, onCreateProductType } = props;


    const handleSubmit = async data => {
        let requestData = { ...data, ActiveCustomerID: activeCustomer }
        let result = await onCreateProductType(requestData);
        if (result) {
            History.goBack();
        }
    };

    const cancelHandler = () => {
        History.goBack();
    };

    let initialValues = {
        Name: "",
        Key: ""
    };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Key: Yup.string().required("Required")
        },
        FormTitle: translations["create_product_type"] || "Create product type",
        ButtonSubmit: hasPermission(permissions, 'product_type_create') ? {
            Title: translations["save"] || "SAVE"
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "Cancel",
            handleCancel: cancelHandler
        }
    };

    return <ProductTypeForm
        formSettings={formSettings}
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        loading={loading}
        translations={translations}
    />
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        loading: state.admin.productType.creating,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onCreateProductType: data => dispatch(actions.createProductType(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductTypeCreate);


/**
 *  Translations
 *      create_product_type
 */